import { render, staticRenderFns } from "./Supported.vue?vue&type=template&id=6c14f3e2&scoped=true&"
var script = {}
import style0 from "./Supported.vue?vue&type=style&index=0&id=6c14f3e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c14f3e2",
  null
  
)

export default component.exports